import React from "react";
import { Box, Grid, Typography, Button, Chip, Avatar } from "@mui/material";
import { Link } from "react-router-dom";
import { skillData } from "./data/data";

const Home = () => {
  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 64px)",
        display: "flex",
        alignItems: "center",
        px: { xs: 3, sm: 6, md: 10, lg: 20, xl: 30 },
        py: { xs: 6, md: 0 },
        justifyContent: "center",
      }}
    >
      <Grid container alignItems="center" justifyContent="center">
        <Grid
          size={{ xs: 12, md: 7 }}
          sx={{ textAlign: { xs: "center", md: "left" } }}
        >
          <Typography
            variant="overline"
            sx={{
              color: "#64ffda",
              letterSpacing: "4px",
              fontSize: "0.85rem",
            }}
          >
            Hello, World 👋
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              color: "#ffffff",
              mt: 1,
              mb: 1,
              fontSize: { xs: "2.5rem", md: "3.5rem" },
            }}
          >
            Bradley Rushforth
          </Typography>

          <Typography
            variant="h4"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 300,
              color: "#64ffda",
              mb: 3,
              fontSize: { xs: "1.5rem", md: "2rem" },
            }}
          >
            Software Developer
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#a8b2d8",
              fontSize: "1.1rem",
              lineHeight: 1.8,
              maxWidth: 540,
              mb: 4,
              mx: { xs: "auto", md: 0 },
            }}
          >
            I build clean, efficient, and scalable applications. Passionate
            about turning complex problems into elegant solutions.
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              mb: 5,
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            {skillData.map((skill) => (
              <Chip
                key={skill.name}
                label={skill.name}
                sx={{
                  backgroundColor: "rgba(100, 255, 218, 0.08)",
                  color: "#64ffda",
                  border: "1px solid rgba(100, 255, 218, 0.3)",
                  fontFamily: "monospace",
                  "&:hover": {
                    backgroundColor: "rgba(100, 255, 218, 0.18)",
                  },
                }}
              />
            ))}
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <Button
              variant="outlined"
              component={Link}
              to="/projects"
              sx={{
                borderColor: "#64ffda",
                color: "#64ffda",
                px: 4,
                py: 1.5,
                fontFamily: "Montserrat, sans-serif",
                letterSpacing: "1px",
                "&:hover": {
                  backgroundColor: "rgba(100, 255, 218, 0.08)",
                  borderColor: "#64ffda",
                },
              }}
            >
              View Projects
            </Button>
            <Button
              variant="contained"
              component={Link}
              to="/contact"
              sx={{
                backgroundColor: "#64ffda",
                color: "#0f0f0f",
                px: 4,
                py: 1.5,
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 700,
                letterSpacing: "1px",
                "&:hover": {
                  backgroundColor: "#45e5be",
                },
              }}
            >
              Contact Me
            </Button>
          </Box>
        </Grid>

        <Grid
          size={{ xs: 12, md: 5 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: { xs: 6, md: 0 },
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: { xs: 220, md: 550 },
              height: { xs: 220, md: 550 },
            }}
          >
            <Avatar
              src="/assets/headshot.png"
              alt="Bradley Rushforth"
              sx={{
                width: "90%",
                height: "100%",
                position: "relative",
                zIndex: 1,
                fontSize: "4rem",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;
